// extracted by mini-css-extract-plugin
export default {"header":"Header_header__rHVPS","loginBlock":"Header_loginBlock__EgM8E","login":"Header_login__EAfLf","icon":"Header_icon__OES+r","link":"Header_link__1FEQM"};